import { settings } from '@/variables.js'
import axios from 'axios'

export const projectsModule = {
  namespaced: true,
  state: {
    title: 'Wat wij maken',
    content: '',
    projects: null,
    disciplines: null
  },
  getters: {},
  mutations: {
    setProjects (state, projects) {
      state.projects = projects
    },
    setDisciplines (state, disciplines) {
      state.disciplines = disciplines
    }
  },
  actions: {
    getProjects (context, projects) {
      axios
        .get(settings.jsonUrl + 'wp/v2/project?per_page=50')
        .then(response => {
          context.commit('setProjects', response.data)
        })
        .catch(error => console.log(error))
    },
    getDisciplines (context, disciplines) {
      axios
        .get(settings.jsonUrl + 'wp/v2/disclipline')
        .then(response => {
          context.commit('setDisciplines', response.data)
        })
        .catch(error => console.log(error))
    }
  }
}
